import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_mt-1 _tac" }
const _hoisted_2 = { class: "gfu-hd gfu-hd--h3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, [
      _renderSlot(_ctx.$slots, "header")
    ]),
    _createElementVNode("p", {
      class: _normalizeClass(["_my-0", { '_mt-1': !$options.isCompactLayout }])
    }, [
      _renderSlot(_ctx.$slots, "subheader")
    ], 2 /* CLASS */)
  ]))
}